import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {SimpleChanges, OnChanges} from '@angular/core';
import {FormGroup, ReactiveFormsModule} from "@angular/forms";
import {NgClass} from "@angular/common";

import {TextBoxModule} from '@syncfusion/ej2-angular-inputs';
import {TooltipModule} from "@syncfusion/ej2-angular-popups";
import {DropDownListModule} from '@syncfusion/ej2-angular-dropdowns';

@Component({
    selector: 'app-form-input',
    imports: [
        ReactiveFormsModule,
        NgClass,
        TextBoxModule,
        TooltipModule,
        DropDownListModule
    ],
    templateUrl: './form-input.component.html',
    styleUrl: './form-input.component.scss'
})
export class FormInputComponent implements OnInit, OnChanges {

  @Input() public type: 'text' | 'search' | 'password' | 'number' = 'text';
  @Input() public placeholder: string = '';
  @Input() public fCN: string = '';
  @Input() public fG: FormGroup = new FormGroup({});
  @Input() public label: string = '';
  @Input() public errorText: string = '';
  @Input() public iconFront: string = '';
  @Input() public iconBack: string = '';
  @Input() public iconClickType: 'none' | 'front' | 'back' | 'both' = 'none';
  @Input() public iconFrontTooltip: string = '';
  @Input() public iconBackTooltip: string = '';
  @Input() public style: 'inline' | 'block' | 'headless' = 'headless';
  @Input() public disabled: boolean = false;
  @Input() public maxChars: number = 0;
  @Input() public cssClass: string = '';
  @Input() public hasErrorField: boolean = true;
  @Input() public wrapperClass: string = '';
  @Input() public autocomplete: string | null = null;
  @Input() public inputName: string | null = null;

  @Output() public  blurred: EventEmitter<void> = new EventEmitter<void>();
  @Output() public  returnKeyPress: EventEmitter<void> = new EventEmitter<void>();
  @Output() public  iconFrontClick: EventEmitter<void> = new EventEmitter<void>();
  @Output() public  iconBackClick: EventEmitter<void> = new EventEmitter<void>();

  public ngOnInit(): void {
    this.setDisabledState(this.disabled);

    if (this.maxChars) {
      this.fG.controls[this.fCN].valueChanges.subscribe((value: string) => {
        if (value?.length > this.maxChars) {
          this.fG.controls[this.fCN].setValue(value.substring(0, this.maxChars));
        }
      });
    }
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes['disabled']) {
      this.setDisabledState(changes['disabled'].currentValue);
    }
  }

  private setDisabledState(disabled: boolean): void {
    const control = this.fG.controls[this.fCN];
    if (!control) return;
    if (disabled) {
      control.disable();
    } else {
      control.enable();
    }
  }

  public canClickFrontIcon(): boolean {
    return this.iconClickType === 'front' || this.iconClickType === 'both';
  }

  public canClickBackIcon(): boolean {
    return this.iconClickType === 'back' || this.iconClickType === 'both';
  }

  public onReturnKeyPress(): void {
    this.returnKeyPress.emit();
  }

  public onIconFrontClicked(): void {
    if (this.iconClickType === 'front' || this.iconClickType === 'both') {
      this.iconFrontClick.emit();
    }
  }

  public onIconBackClicked(): void {
    // Clear the input and dropdown selection if the type is 'search'
    if (this.type === 'search') {
      this.fG.controls[this.fCN].setValue('');
    }
    if (this.iconClickType === 'back' || this.iconClickType === 'both') {
      this.iconBackClick.emit();
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public onInput(event: Event): void {
    // TODO what to do here?
    // const inputElement = event.target as HTMLInputElement;
  }

  public onBlur(): void {
    if (!this.disabled) {
      this.blurred.emit();
    }
  }
}
